import { loadImage } from "./load-image";

export type LoadImageUrlOutput = { image: HTMLImageElement; imageUrl: string };

export const loadImageUrl = (obj: Blob | MediaSource): Promise<LoadImageUrlOutput> => {
  const imageUrl = URL.createObjectURL(obj);

  return new Promise<LoadImageUrlOutput>((resolve, reject) => {
    loadImage(imageUrl)
      .then((image) => resolve({ image, imageUrl }))
      .catch(reject);
  });
};
